import { NavLink } from 'react-router-dom'
import { styled } from 'styled-components'

import { Bar } from 'peach/components'

import { headerItemStyle } from './headerStyles'
import MainMenu from './MainMenu'
import Search from './Search'

// const emoji = '⚗️ 😮👤👀👁👨‍💻👨‍💻🧶🧵🧤🎩🐲'
// const companies = ['🧐', '🎩', '🏢', '🏬', '🕋', '📠']
// const people = ['👤', '👥', '😼', '⛄️']
// const tools = ['🍑', '🪓', '🧰', '🗜', '⛏', '🔭', '🔬', '🔩', '🔨', '🔧', '🛠']

// const company = '🏢'
// const tool = '🛠'

const AppHeader = () => (
  <StyledBar
    left={
      <Bar.Section>
        <Search />
      </Bar.Section>
    }
    right={
      <Bar.Section>
        <NavItem to='/scratch'>📝</NavItem>
        <NavItem to='/api'>🛠</NavItem>
        {/* <AppUserInfo /> */}
        <MainMenu />
      </Bar.Section>
    }
  />
)

export default AppHeader

const StyledBar = styled(Bar)`
  position: relative;
  z-index: 10;
`

const NavItem = styled(NavLink)`
  ${headerItemStyle}
`
